<template>
  <div class="d-flex align-items-center">
    <b-form-group class="col-7" :label="translations.filters.client_id">
      <b-form-select v-model="filter_set.client_id" :disabled="disabled" :options="filter_options.clients"/>
    </b-form-group>
    <b-form-group :label="translations.filters.year_month" class="col-4">
      <year-month-input v-model="filter_set.year_month" :disabled="disabled"/>
    </b-form-group>
    <b-button variant="primary" class="mt-2 col-1" @click="applyFilters" :disabled="disabled">
      {{ translations.filters.search }}
    </b-button>
  </div>
</template>

<script>
import YearMonthInput from '@/components/Financial/YearMonthInput.vue';
import translations from '@/translations';

export default {
  name: 'MonthlyRevenueListFilters',
  components: {
    YearMonthInput,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      translations: translations.finance.monthly_revenue,
      filter_set: {
        client_id: null,
        year_month: null,
      },
      filter_options: {
        clients: [
          { value: '', text: translations.finance.monthly_revenue.filters.default_client_filter },
        ],
      },
    };
  },
  async beforeMount() {
    await this.loadFilters();
  },
  methods: {
    applyFilters() {
      const filters = {
        client_id: this.filter_set.client_id,
        year_month: this.filter_set.year_month,
      };
      this.$emit('apply-filters', filters);
    },
    async loadFilters() {
      try {
        const clients = await this.$store.dispatch('Core/fetchClients');
        const responseFilters = clients
          .sort((a, b) => a.display_name.localeCompare(b.display_name))
          .map(({ id: value, display_name: displayName }) => ({ value, text: `${displayName} (ID: ${value})` }));

        this.filter_options.clients = [ ...this.filter_options.clients, ...responseFilters ];
      } catch (_) {
        this.$noty.error(this.translations.errors.loading_filters);
      }
    },
  },
};
</script>
